export const BRAND = {
  name: "RemindMe & Do",
  domain: "minemeanddo.com",
  keyword: "START",
  number: "+1 (904) 830-9661",
  numberTollfree: "+1 (888) 576-6585",
  email: "hello@minemeanddo.com",
};

export const TERMS_URL = "https://minemeanddo.com/terms";
export const PRIVACY_URL = "https://minemeanddo.com/privacy";

export const WELCOME_MESSAGE =
  "RemindMe & Do: Welcome! You are now opted in to receive automated task reminders and schedule updates. Msg frequency varies. Msg&DataRatesMayApply. Reply HELP for help, STOP to cancel. Terms: https://minemeanddo.com/terms Privacy: https://minemeanddo.com/privacy";

export const DISCLOSURE_COPY =
  "By texting START to +1 (904) 830-9661 or checking the box below, you agree to receive recurring automated task reminder text messages from RemindMe & Do. Consent is not a condition of purchase. Message frequency varies based on your tasks. Message & data rates may apply. Reply HELP for assistance, or STOP to unsubscribe at any time. View our Terms of Service and Privacy Policy.";

export const SAMPLE_REMINDERS = [
  "Buy groceries @ 5 PM",
  "Dry cleaning pick-up",
  "Team sync in 15 min",
  "Meds reminder @ 9 AM",
  "Water the plants",
  "Call mom back",
  "Text START to opt in",
  "Reply STOP to cancel",
];
